import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const pricingCategoryApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const pricingCategorySchema = v.object({
  ...pricingCategoryApiSchema.entries,
  ...optionSchema.entries,
});

export const pricingCategoriesApiSchema = paginatedSchema(pricingCategoryApiSchema);

export type PricingCategoryApi = v.InferOutput<typeof pricingCategoryApiSchema>;
export type PricingCategoriesApi = v.InferOutput<typeof pricingCategoriesApiSchema>;

export type PricingCategoryFilters = Filters<PricingCategoryApi>;

export type PricingCategoryFiltersUpdateApi = FiltersUpdateApi<PricingCategoryApi>;

export type PricingCategory = Prettify<Option<v.InferOutput<typeof pricingCategorySchema>>>;

export type PricingCategories = Entities<PricingCategory>;
